import { useState } from "react";
import apiClient from "../api/axios";

/**
 * Hook for driver assignment API operations
 */
const useDriverAssignmentApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get nearby drivers for an order
  const getNearbyDrivers = async (orderId, maxDistance = null) => {
    setLoading(true);
    setError(null);

    try {
      const params = { order_id: orderId };
      if (maxDistance) params.max_distance = maxDistance;

      const queryString = new URLSearchParams(params).toString();
      const response = await apiClient.get(`/admin/nearby-drivers?${queryString}`);

      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  // Auto assign drivers to an order
  const autoAssignDrivers = async (orderId) => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.post('/admin/auto-assign-drivers', { order_id: orderId });
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  // Manually assign selected drivers to an order
  const manualAssignDrivers = async (orderId, driverIds) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await apiClient.post('/admin/manual-assign-drivers', {
        order_id: orderId,
        driver_ids: driverIds
      });
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  // Get assignment status for an order
  const getAssignmentStatus = async (orderId) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await apiClient.get(`/admin/assignment-status?order_id=${orderId}`);
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  return {
    getNearbyDrivers,
    autoAssignDrivers,
    manualAssignDrivers,
    getAssignmentStatus,
    loading,
    error,
    setError
  };
};

export default useDriverAssignmentApi;
